import React from 'react';

import { Title } from '@components/Title';

import { PageHeaderContainer } from './PageHeader.styled';
import { PageHeaderProps } from './PageHeader.types';

export const PageHeader = ({ text, headerColor }: PageHeaderProps) => (
  <PageHeaderContainer>
    <Title color={headerColor} text={text} align="left" />
  </PageHeaderContainer>
);
